/**
 * Năm kiểu xem của trang Tệp — docs/plan-my-files.md §4.2, giống trình quản lý
 * file của Windows.
 *
 * Kiểu xem là **thói quen của người xem**, không phải của link: `?view=` trên
 * URL thắng khi có (gửi link "xem dạng lưới" cho người khác vẫn đúng), còn
 * không thì lấy lựa chọn lần trước từ `localStorage`.
 */
export const MY_FILES_VIEWS = ['details', 'list', 'medium', 'large', 'tiles'] as const;
export type MyFilesView = (typeof MY_FILES_VIEWS)[number];

export const DEFAULT_MY_FILES_VIEW: MyFilesView = 'details';

const STORAGE_KEY = 'apm.myFiles.view';

function isView(value: unknown): value is MyFilesView {
  return typeof value === 'string' && (MY_FILES_VIEWS as readonly string[]).includes(value);
}

/**
 * Lựa chọn đã nhớ. `localStorage` có thể ném (cửa sổ ẩn danh, bị chặn) hoặc
 * trả rác — cả hai rơi về mặc định, không bao giờ làm trắng trang.
 */
export function readStoredView(): MyFilesView {
  try {
    const stored = window.localStorage.getItem(STORAGE_KEY);
    return isView(stored) ? stored : DEFAULT_MY_FILES_VIEW;
  } catch {
    return DEFAULT_MY_FILES_VIEW;
  }
}

export function storeView(view: MyFilesView): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, view);
  } catch {
    // Không nhớ được thì thôi — kiểu xem vẫn đổi trong phiên này qua URL.
  }
}
